import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Typography,
    Tabs,
    useCRUDController,
    Select,
    Button,
    MainModal,
    Form,
    message
} from "../../ui/ot";
import { useTranslation } from "react-i18next";
import { Star, Settings } from "lucide-react"
import { useSearchParams } from "react-router-dom";
import LibrarySwitchForm from './library_switch_form'
const LibrarySwitch = ({
    keyPrefix = "library.backstage.library_switch",
    onChange = () => { }
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [form] = Form.useForm();
    const [modalOpen, setModalOpen] = useState(false)
    const [staffLibrary, setStaffLibrary] = useState({
        user_id: "",
        staff_id: "",
        branchcode: "",
        branchname: ""
    })
    const onFormFinish = (value) => {
        staffController.patchData([
            {
                ...value
            }
        ])
    }
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "patch") {
                message.success(t('modify_success'));
                getLibrarySelf()
            }
        } else if (status === "error") {
            if (axiosMode === "patch") {
                message.error(t('modify_failure'));
                getLibrarySelf()
            }
        }
        setModalOpen(false)
    };
    const staffSelfController = useCRUDController({
        apiRoute: "/library/organization_structure/api/staff/concatenation_self"
    })
    const staffController = useCRUDController({
        apiRoute: "/library/organization_structure/api/staff/concatenation",
        onFinish: onFinish
    })
    const getLibrarySelf = () => {
        staffSelfController.getData({})
            .then((response) => {
                let data = response?.data || []
                let firstData = data?.find((ele) => true)
                setStaffLibrary({
                    ...firstData
                })
            })
    }
    useEffect(() => {
        getLibrarySelf()
    }, [])
    useEffect(()=>{
        onChange(staffLibrary)
    },[staffLibrary])
    return (<Row gutter={[4, 4]} align="middle">
        <MainModal
            axiosMode={'patch'}
            propsForm={form}
            propsOpen={modalOpen}
            propsSetOpen={setModalOpen}
            onFinish={onFormFinish}
            width={600}
            formElement={<LibrarySwitchForm />}
            keyPrefix={keyPrefix}
            propsLoading={false}
        />
        <Col >
            <Button
            className="text-lg text-blue-600 hover:text-blue-800 p-0 h-auto"
            type="text"
             onClick={() => {
                setModalOpen(true)
                form.setFieldsValue({
                    ...staffLibrary
                })
            }} >
                <Typography.P>{staffLibrary?.branchcode} -{staffLibrary?.branchname}</Typography.P><Settings />
            </Button>
        </Col>
    </Row>)
}
export default LibrarySwitch

